module.exports = __webpack_public_path__ + "img/public_pool.e3af0348.png";